import Annotation from "./annotation";
import { EyeMarkers } from "../../config/config";
import { setLineStyle, setFontStyle } from "../canvasUtils";

export default class EyeMarker extends Annotation {
  constructor() {
    super();

    this.eyeMarker = EyeMarkers.None;
    this.theta = 0;

    this.boxSize = 18;
    this.textDistance = 23;
    this.flangeLength = 10;
    this.flangeAngle = 4 * Math.PI / 5;

    this.lineWidth = 1;
    this.font = "14px Calibri";
    this.baseline = "hanging";
    this.fontColor = "white";

    this.text1 = "";
    this.text2 = "";

    this.canvasSize = null;
  }

  draw(ctx){
    if(!this.canvasSize) return;

    let w = this.canvasSize.w;
    let h = this.canvasSize.h;

    let centerX = w - this.boxSize * 2;
    let centerY = h - this.boxSize * 2;
    setLineStyle(ctx, this);
    ctx.strokeRect(centerX - this.boxSize, centerY - this.boxSize, this.boxSize * 2, this.boxSize * 2);

    let start = this.getPosition(centerX, centerY, -this.boxSize, this.theta);
    let end = this.getPosition(centerX, centerY, this.boxSize, this.theta);
    let flange1 = this.getPosition(end.x, end.y, this.flangeLength, this.theta - this.flangeAngle);
    let flange2 = this.getPosition(end.x, end.y, this.flangeLength, this.theta + this.flangeAngle);
    let textStart = this.getPosition(centerX, centerY, -this.textDistance, this.theta);
    let textEnd = this.getPosition(centerX, centerY, this.textDistance, this.theta);

    ctx.beginPath();
    ctx.moveTo(start.x, start.y);
    ctx.lineTo(end.x, end.y);
    ctx.lineTo(flange1.x, flange1.y);
    ctx.moveTo(end.x, end.y)
    ctx.lineTo(flange2.x, flange2.y);
    ctx.closePath();
    ctx.stroke();
    
    setFontStyle(ctx, this);
    let width = ctx.measureText(this.text1).width;
    // adjust based on the angle to account for how canvas positions text
    let cosT = Math.cos(this.theta);
    let sinT = Math.sin(this.theta);
    let startX = cosT * width;
    let startY = cosT * 6;
    let endX = sinT * width / 2;
    let endY = sinT * 14;
    if (this.theta == Math.PI) {
      ctx.fillText(this.text1, textStart.x, textStart.y + startY);
      ctx.fillText(this.text2, textEnd.x + startX, textEnd.y - endY + startY);
    }
    else {
      ctx.fillText(this.text1, textStart.x - startX + endX, textStart.y - startY);
      ctx.fillText(this.text2, textEnd.x + endX, textEnd.y + endY - startY);
    }
  }

  getPosition(centerX, centerY, length, angle){
    return {
      x: centerX + length * Math.cos(angle),
      y: centerY + length * Math.sin(angle)
    }
  }

  updateMarker(marker){
    this.eyeMarker = marker;

    switch (this.eyeMarker) {
      case EyeMarkers.SI:
        this.text1 = "S";
        this.text2 = "I";
        break;
      case EyeMarkers.IS:
        this.text1 = "I";
        this.text2 = "S";
        break;
      case EyeMarkers.TN:
        this.text1 = "T";
        this.text2 = "N";
        break;
      case EyeMarkers.NT:
        this.text1 = "N";
        this.text2 = "T";
        break;
      default:
        this.text1 = "";
        this.text2 = "";
    }
    this.signalReady();
  }

  updateTheta(theta){
    this.theta = theta;
    this.signalReady();
  }
}